const REACT_APP_ENVIRONMENT_TYPE = process.env.REACT_APP_ENVIRONMENT_TYPE

export let BACKEND_URL = (REACT_APP_ENVIRONMENT_TYPE === "dev" ? "http://127.0.0.1:8000/graphql/" : "https://monkfish-app-4vcff.ondigitalocean.app/graphql/")
export let BACKEND_REST_API = (REACT_APP_ENVIRONMENT_TYPE === "dev" ? "http://127.0.0.1:8000/api/" : "https://monkfish-app-4vcff.ondigitalocean.app/api/")

export const BACKEND_INDICES_EXTERNAL = 'indices_external/'

export const AUTH_TOKEN = 'auth-token-investitum';

